var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogoLogin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_12",
    "data-name": "Group 12",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 288.652,
    height: 60.949,
    viewBox: "0 0 288.652 60.949",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_12",
    "data-name": "Rectangle 12",
    width: 288.652,
    height: 60.949,
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_11",
    "data-name": "Group 11",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4",
    "data-name": "Path 4",
    d: "M137.986,106.392a31.923,31.923,0,0,1-8.639-1.364l.546-1.819c7.638,2.182,13.458,1.546,15.186-1.455,2.365-4.183-3.091-12.458-12.913-19.278l1.092-1.546c10.912,7.638,16.459,16.55,13.458,21.733-1.455,2.455-4.547,3.728-8.73,3.728",
    transform: "translate(-96.793 -60.562)",
    fill: "#004ede"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5",
    "data-name": "Path 5",
    d: "M15.408,66.3A42.149,42.149,0,0,1,4.4,55.2c-2.546-4-3.091-7.457-1.546-10.094,2.455-4.183,9.82-4.819,19.278-1.728L21.5,45.2c-8.457-2.728-15.095-2.364-17,.91C2.131,50.2,7.223,58.021,16.589,64.749Z",
    transform: "translate(-1.495 -31.013)",
    fill: "#004ede"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6",
    "data-name": "Path 6",
    d: "M129.26,40.483c-.182-.637-.455-1.364-.637-1.91l1.728-.637c.273.637.455,1.364.727,2Z",
    transform: "translate(-96.251 -28.389)",
    fill: "#004ede"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7",
    "data-name": "Path 7",
    d: "M64.3,56.2c-3.365,0-6.365-3-8.639-8.548-2.091-5.183-3.274-12.185-3.274-19.55A54.611,54.611,0,0,1,55.662,8.548C57.935,3.092,60.936,0,64.3,0c2.091,0,4.183,1.273,5.911,3.546L68.665,4.638c-1-1.273-2.546-2.819-4.456-2.819-2.455,0-5,2.637-6.911,7.365a52.531,52.531,0,0,0-3.183,18.823c0,7.093,1.091,13.822,3.183,18.823,1.91,4.638,4.365,7.365,6.911,7.365,3.092,0,6.183-4.183,8.093-10.821l1.819.546C71.939,51.741,68.392,56.2,64.3,56.2",
    transform: "translate(-39.203)",
    fill: "#004ede"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8",
    "data-name": "Path 8",
    d: "M19.52,82.828l-1.455-1.182A52.818,52.818,0,0,1,32.978,69.37l.909,1.637A47.661,47.661,0,0,0,19.52,82.828",
    transform: "translate(-13.518 -51.911)",
    fill: "#004ede"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9",
    "data-name": "Path 9",
    d: "M11.417,151c-4.183,0-7.275-1.273-8.73-3.728a7.845,7.845,0,0,1-.091-6.729l1.728.636q-1.228,3.137,0,5.183c1.182,2,3.91,2.637,6,2.728a30.932,30.932,0,0,0,11.366-1.91L22.329,149a35.3,35.3,0,0,1-10.912,2",
    transform: "translate(-1.414 -105.173)",
    fill: "#004ede"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10",
    "data-name": "Path 10",
    d: "M137.4,66.454l-1.091-1.546c4.729-3.365,8.639-7.184,10.821-10.73,2.182-3.364,2.728-6.365,1.637-8.275-1.637-2.819-7-3.546-13.913-1.819l-.455-1.819a27.338,27.338,0,0,1,9.821-.818c3,.455,5.092,1.637,6.183,3.546,1.546,2.637.909,6.184-1.636,10.185A40.553,40.553,0,0,1,137.4,66.454",
    transform: "translate(-100.575 -30.899)",
    fill: "#004ede"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11",
    "data-name": "Path 11",
    d: "M117.537,18.657a3.728,3.728,0,1,1,3.728-3.728,3.806,3.806,0,0,1-3.728,3.728m0-5.547a1.819,1.819,0,1,0,1.819,1.819,1.824,1.824,0,0,0-1.819-1.819",
    transform: "translate(-85.165 -8.382)",
    fill: "#004ede"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12",
    "data-name": "Path 12",
    d: "M3.728,123.434a3.728,3.728,0,1,1,0-7.456,3.728,3.728,0,1,1,0,7.456m0-5.547a1.819,1.819,0,1,0,1.819,1.819,1.824,1.824,0,0,0-1.819-1.819",
    transform: "translate(0 -86.788)",
    fill: "#004ede"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13",
    "data-name": "Path 13",
    d: "M55.84,113.506a1.08,1.08,0,0,1-1.091-.909,65.325,65.325,0,0,1-1.455-7.093,54.28,54.28,0,0,1-.546-7.729V97.5l.091-.182a11.566,11.566,0,0,1,1.637-2.455,11.723,11.723,0,0,1,3-2.546,8.586,8.586,0,0,1,2.091-.909l.364,1.728a8.319,8.319,0,0,0-1.546.818,10.712,10.712,0,0,0-2.455,2.091,12.953,12.953,0,0,0-1.273,1.819,55.065,55.065,0,0,0,1.819,13.367l1.091-.273,1.91-.546.546,1.819-1.91.546a17.713,17.713,0,0,1-1.819.455c-.272.273-.363.273-.454.273",
    transform: "translate(-39.472 -68.403)",
    fill: "#004ede"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_14",
    "data-name": "Path 14",
    d: "M83.688,78.5h4.365a3.565,3.565,0,0,0,3.091-1.091c.818-1,.727-2.273.727-3.455V51.406c0-1.273.273-2.819-.182-4a3.069,3.069,0,0,0-2.637-2c-1.364-.091-2.728,0-4.092,0H80.505c-1.364,0-2.819-.091-4.274,0a3.053,3.053,0,0,0-2.728,2,10.336,10.336,0,0,0-.273,3.364c-.091,5.092,0,10.093.091,15.186,0,1.273,2.091,1.273,2,0-.091-4.365-.091-8.73-.091-13,0-1.182,0-2.364.091-3.637a3.732,3.732,0,0,1,.091-1c.273-1.091,1.455-.909,2.365-.909h9.912a7.763,7.763,0,0,1,1.455,0c1,.273.818,1.546.818,2.364v25.37c0,1.182-.727,1.364-1.636,1.364H83.78a1,1,0,1,0-.091,2",
    transform: "translate(-54.772 -33.946)",
    fill: "#004ede"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_15",
    "data-name": "Path 15",
    d: "M73.706,122.532a2.143,2.143,0,0,0,1.091,2.182,2.391,2.391,0,0,0,2.455-.364c.546-.364,1.455-.909,2.091-.455a.867.867,0,0,1,.273,1.091,6.266,6.266,0,0,1-1.455,1.637c-.727.637-1.546,1.182-2.273,1.819a6.08,6.08,0,0,0-1.819,1.91,3.519,3.519,0,0,0-.273,2.364,3.1,3.1,0,0,0,1.546,2.364,5.907,5.907,0,0,0,2.819.364,1,1,0,0,0,0-2c-.727,0-1.91.273-2.273-.636a1.571,1.571,0,0,1,.455-2c1.546-1.364,3.365-2.455,4.638-4.092a3.094,3.094,0,0,0-.637-4.638,3.3,3.3,0,0,0-3.183,0,8.322,8.322,0,0,0-1.182.728c-.182.091-.091.091-.273.091h0v-.364c.09-1.273-1.911-1.273-2,0",
    transform: "translate(-55.155 -90.979)",
    fill: "#004ede"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_16",
    "data-name": "Path 16",
    d: "M93.942,75.873H95.4a.333.333,0,0,1,.364.364v1.455a.333.333,0,0,1-.364.364H93.942a.333.333,0,0,1-.364-.364V76.237c0-.091.182-.364.364-.364",
    transform: "translate(-70.026 -56.777)",
    fill: "#004ede"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_17",
    "data-name": "Path 17",
    d: "M93.942,99.358H95.4a.333.333,0,0,1,.364.364v1.455a.333.333,0,0,1-.364.364H93.942a.333.333,0,0,1-.364-.364V99.813a.416.416,0,0,1,.364-.455",
    transform: "translate(-70.026 -74.351)",
    fill: "#004ede"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_18",
    "data-name": "Path 18",
    d: "M117.717,99.358h1.455a.333.333,0,0,1,.364.364v1.455a.333.333,0,0,1-.364.364h-1.455a.333.333,0,0,1-.364-.364V99.813c-.091-.273.091-.455.364-.455",
    transform: "translate(-87.8 -74.351)",
    fill: "#004ede"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_19",
    "data-name": "Path 19",
    d: "M117.979,90.879H116.8a.818.818,0,1,1,0-1.637h1.182a.818.818,0,0,1,0,1.637",
    transform: "translate(-86.789 -66.781)",
    fill: "#004ede"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_20",
    "data-name": "Path 20",
    d: "M107.4,101.093a.815.815,0,0,1-.818-.818V99.092a.818.818,0,1,1,1.636,0v1.182a.815.815,0,0,1-.818.818",
    transform: "translate(-79.759 -73.54)",
    fill: "#004ede"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_21",
    "data-name": "Path 21",
    d: "M117.888,78.6a.815.815,0,0,1-.818-.818V77.51H116.8a.818.818,0,0,1,0-1.637h1a.815.815,0,0,1,.818.818v1a.732.732,0,0,1-.728.909",
    transform: "translate(-86.789 -56.777)",
    fill: "#004ede"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_22",
    "data-name": "Path 22",
    d: "M97.67,81.145H94.4a.818.818,0,0,1,0-1.637h2.455V77.053a.818.818,0,1,1,1.636,0v3.273a.815.815,0,0,1-.818.818",
    transform: "translate(-70.026 -57.048)",
    fill: "#004ede"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_23",
    "data-name": "Path 23",
    d: "M91.163,160.286a3.728,3.728,0,1,1,3.728-3.728,3.688,3.688,0,0,1-3.728,3.728m0-5.547a1.819,1.819,0,1,0,1.819,1.819,1.768,1.768,0,0,0-1.819-1.819",
    transform: "translate(-65.429 -114.365)",
    fill: "#004ede"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_24",
    "data-name": "Path 24",
    d: "M275.162,53.263a6.9,6.9,0,0,0-3.238-3.237,10.7,10.7,0,0,0-10.3.294,10.385,10.385,0,0,0-3.825,4.12,14.4,14.4,0,0,0,0,12.067,10.251,10.251,0,0,0,3.825,4.12,12.172,12.172,0,0,0,5.591,1.472,9.514,9.514,0,0,0,6.475-2.06,8.439,8.439,0,0,0,3.238-5.886H265.155v-5.3h18.835v6.18a19.773,19.773,0,0,1-2.943,6.769,16.223,16.223,0,0,1-5.886,5,18.433,18.433,0,0,1-7.947,1.766,20.03,20.03,0,0,1-9.124-2.354,18.554,18.554,0,0,1-6.475-6.18,19.958,19.958,0,0,1,0-18.247,14.645,14.645,0,0,1,6.475-6.18,19.115,19.115,0,0,1,9.124-2.354A16.116,16.116,0,0,1,277.221,46.2a13.349,13.349,0,0,1,5.886,7.946Z",
    transform: "translate(-186.637 -32.37)",
    fill: "#004ede"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_25",
    "data-name": "Path 25",
    d: "M414.632,46.51v8.535H426.4v5.592H414.632V69.76h13.244v5.592H407.864V40.918h20.012V46.51Z",
    transform: "translate(-305.211 -30.62)",
    fill: "#004ede"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_26",
    "data-name": "Path 26",
    d: "M541.659,75.646H534.6L519,51.808V75.646h-7.063V40.918H519l15.6,23.839V40.918h7.063Z",
    transform: "translate(-383.09 -30.62)",
    fill: "#004ede"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_27",
    "data-name": "Path 27",
    d: "M664.871,46.51v8.535h11.772v5.592H664.871V69.76h13.244v5.592H658.1V40.918h20.012V46.51Z",
    transform: "translate(-492.47 -30.62)",
    fill: "#004ede"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_28",
    "data-name": "Path 28",
    d: "M783.657,40.918V46.51H769.237v8.829H780.42v5.592H769.237V75.646h-7.063V40.918Z",
    transform: "translate(-570.348 -30.62)",
    fill: "#004ede"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_9",
    "data-name": "Rectangle 9",
    width: 7.063,
    height: 34.728,
    transform: "translate(218.019 10.298)",
    fill: "#004ede"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_29",
    "data-name": "Path 29",
    d: "M929.145,46.51v8.535h11.772v5.592H929.145V69.76h13.244v5.592H922.376V40.918h20.012V46.51Z",
    transform: "translate(-690.23 -30.62)",
    fill: "#004ede"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_30",
    "data-name": "Path 30",
    d: "M1047.055,42.978a16.362,16.362,0,0,1,6.475,6.18,20.028,20.028,0,0,1,2.354,9.123,16.733,16.733,0,0,1-8.829,15.3,21.323,21.323,0,0,1-9.712,2.06h-12.067V40.918h12.067a21.323,21.323,0,0,1,9.712,2.06m-1.177,23.839c2.061-2.06,2.943-4.709,2.943-8.535,0-3.532-.882-6.475-2.943-8.535s-4.709-2.943-8.535-2.943h-5V69.76h5a12.993,12.993,0,0,0,8.535-2.943",
    transform: "translate(-767.232 -30.62)",
    fill: "#004ede"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31",
    "data-name": "Path 31",
    d: "M279.047,208.208v2.649h3.014v1.105h-3.014v2.75h3.39v1.117h-4.822v-8.74h4.822v1.117Z",
    transform: "translate(-207.744 -154.969)",
    fill: "#004ede"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32",
    "data-name": "Path 32",
    d: "M306.83,211.51l2.712,4.357h-1.607l-1.971-3.164-1.846,3.164H302.51l2.712-4.357-2.712-4.37h1.607l1.971,3.177,1.858-3.177h1.607Z",
    transform: "translate(-226.374 -155.006)",
    fill: "#004ede"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33",
    "data-name": "Path 33",
    d: "M338.118,212.326v3.541h-1.431V207.14H339.7a3.807,3.807,0,0,1,1.7.345,2.4,2.4,0,0,1,1.042.936,2.561,2.561,0,0,1,.345,1.318,2.635,2.635,0,0,1-.314,1.256,2.353,2.353,0,0,1-1,.961,3.728,3.728,0,0,1-1.77.37Zm2.8-1.507a1.434,1.434,0,0,0,.4-1.08,1.451,1.451,0,0,0-.4-1.093,1.691,1.691,0,0,0-1.218-.389h-1.582v2.951H339.7a1.69,1.69,0,0,0,1.218-.389",
    transform: "translate(-251.949 -155.006)",
    fill: "#004ede"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_34",
    "data-name": "Path 34",
    d: "M371.187,207.263a4.2,4.2,0,0,1,1.614,1.589,4.781,4.781,0,0,1,0,4.6,4.19,4.19,0,0,1-1.614,1.595,4.707,4.707,0,0,1-4.5,0,4.232,4.232,0,0,1-1.62-1.595,4.737,4.737,0,0,1,0-4.6,4.246,4.246,0,0,1,1.62-1.589,4.709,4.709,0,0,1,4.5,0m-3.8,1.124a2.726,2.726,0,0,0-1.061,1.105,3.457,3.457,0,0,0-.383,1.658,3.5,3.5,0,0,0,.383,1.664,2.76,2.76,0,0,0,1.061,1.117,3.213,3.213,0,0,0,3.089,0,2.762,2.762,0,0,0,1.061-1.117,3.5,3.5,0,0,0,.383-1.664,3.46,3.46,0,0,0-.383-1.658,2.728,2.728,0,0,0-1.061-1.105,3.258,3.258,0,0,0-3.089,0",
    transform: "translate(-272.743 -154.671)",
    fill: "#004ede"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35",
    "data-name": "Path 35",
    d: "M412.658,215.829h-1.431l-4.307-6.517v6.517h-1.431v-8.74h1.431l4.307,6.5v-6.5h1.431Z",
    transform: "translate(-303.434 -154.969)",
    fill: "#004ede"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_36",
    "data-name": "Path 36",
    d: "M442.891,208.208v2.649h3.014v1.105h-3.014v2.75h3.39v1.117H441.46v-8.74h4.822v1.117Z",
    transform: "translate(-330.352 -154.969)",
    fill: "#004ede"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_37",
    "data-name": "Path 37",
    d: "M474.773,215.829h-1.431l-4.307-6.517v6.517H467.6v-8.74h1.431l4.307,6.5v-6.5h1.431Z",
    transform: "translate(-349.915 -154.969)",
    fill: "#004ede"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_38",
    "data-name": "Path 38",
    d: "M507.869,207.14v1.117h-2.323v7.61h-1.432v-7.61h-2.336V207.14Z",
    transform: "translate(-375.489 -155.006)",
    fill: "#004ede"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_10",
    "data-name": "Rectangle 10",
    width: 1.431,
    height: 8.727,
    transform: "translate(133.823 52.133)",
    fill: "#004ede"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_39",
    "data-name": "Path 39",
    d: "M548.615,214.047h-3.654l-.628,1.783h-1.495l3.127-8.74h1.657l3.127,8.74h-1.507Zm-.389-1.117-1.431-4.106-1.444,4.106Z",
    transform: "translate(-406.216 -154.969)",
    fill: "#004ede"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_40",
    "data-name": "Path 40",
    d: "M581.092,214.774h2.951v1.093h-4.382V207.14h1.431Z",
    transform: "translate(-433.77 -155.006)",
    fill: "#004ede"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_41",
    "data-name": "Path 41",
    d: "M621.82,207.375a3.9,3.9,0,0,1,1.576,1.94h-1.72a2.311,2.311,0,0,0-.942-.986A2.838,2.838,0,0,0,619.34,208a3.044,3.044,0,0,0-1.545.389,2.728,2.728,0,0,0-1.061,1.1,3.459,3.459,0,0,0-.383,1.658,3.5,3.5,0,0,0,.383,1.664,2.718,2.718,0,0,0,1.061,1.111,3.044,3.044,0,0,0,1.545.389,2.74,2.74,0,0,0,1.9-.659,2.809,2.809,0,0,0,.885-1.789H618.85v-1.118h4.809v1.118a4.311,4.311,0,0,1-4.32,3.742,4.511,4.511,0,0,1-2.248-.571,4.26,4.26,0,0,1-1.614-1.589,4.725,4.725,0,0,1,0-4.6,4.242,4.242,0,0,1,1.62-1.588,4.762,4.762,0,0,1,4.721.113",
    transform: "translate(-460.127 -154.67)",
    fill: "#004ede"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_42",
    "data-name": "Path 42",
    d: "M659.841,215.867l-2.185-3.541h-.879v3.541h-1.431V207.14h3.013a3.808,3.808,0,0,1,1.7.345,2.4,2.4,0,0,1,1.042.936,2.522,2.522,0,0,1-1.827,3.817l2.31,3.629Zm-3.064-4.659h1.582a1.69,1.69,0,0,0,1.218-.389,1.434,1.434,0,0,0,.4-1.08,1.452,1.452,0,0,0-.4-1.093,1.691,1.691,0,0,0-1.218-.389h-1.582Z",
    transform: "translate(-490.407 -155.006)",
    fill: "#004ede"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_43",
    "data-name": "Path 43",
    d: "M691.693,207.263a4.2,4.2,0,0,1,1.614,1.589,4.781,4.781,0,0,1,0,4.6,4.188,4.188,0,0,1-1.614,1.595,4.707,4.707,0,0,1-4.5,0,4.23,4.23,0,0,1-1.62-1.595,4.737,4.737,0,0,1,0-4.6,4.245,4.245,0,0,1,1.62-1.589,4.709,4.709,0,0,1,4.5,0m-3.8,1.124a2.728,2.728,0,0,0-1.061,1.105,3.461,3.461,0,0,0-.383,1.658,3.5,3.5,0,0,0,.383,1.664,2.762,2.762,0,0,0,1.061,1.117,3.212,3.212,0,0,0,3.089,0,2.758,2.758,0,0,0,1.061-1.117,3.5,3.5,0,0,0,.383-1.664,3.458,3.458,0,0,0-.383-1.658,2.724,2.724,0,0,0-1.061-1.105,3.258,3.258,0,0,0-3.089,0",
    transform: "translate(-512.583 -154.671)",
    fill: "#004ede"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_44",
    "data-name": "Path 44",
    d: "M735.266,207.14l-2.587,8.727h-1.62l-1.833-6.6-1.946,6.6-1.607.013-2.474-8.74h1.519l1.808,7.107,1.959-7.107h1.607l1.821,7.07,1.821-7.07Z",
    transform: "translate(-541.182 -155.006)",
    fill: "#004ede"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_45",
    "data-name": "Path 45",
    d: "M780.13,207.14v1.117h-2.323v7.61h-1.432v-7.61H774.04V207.14Z",
    transform: "translate(-579.227 -155.006)",
    fill: "#004ede"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_46",
    "data-name": "Path 46",
    d: "M810.944,207.14v8.727h-1.432v-3.855h-4.106v3.855h-1.431V207.14h1.431v3.767h4.106V207.14Z",
    transform: "translate(-601.629 -155.006)",
    fill: "#004ede"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_47",
    "data-name": "Path 47",
    d: "M857.846,214.047h-3.654l-.628,1.783H852.07l3.127-8.74h1.657l3.127,8.74h-1.507Zm-.389-1.117-1.432-4.106-1.444,4.106Z",
    transform: "translate(-637.619 -154.969)",
    fill: "#004ede"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_48",
    "data-name": "Path 48",
    d: "M893.86,214.3a2.614,2.614,0,0,1-1.049.954,3.426,3.426,0,0,1-1.62.364,3.562,3.562,0,0,1-2.2-.641,2.089,2.089,0,0,1-.854-1.771h1.532a1.339,1.339,0,0,0,.427.917,1.581,1.581,0,0,0,1.092.339,1.681,1.681,0,0,0,1.162-.377,1.239,1.239,0,0,0,.421-.967,1.02,1.02,0,0,0-.258-.735,1.693,1.693,0,0,0-.647-.415,9.88,9.88,0,0,0-1.067-.308,9.094,9.094,0,0,1-1.381-.42,2.219,2.219,0,0,1-.9-.7,2.08,2.08,0,0,1-.377-1.312,2.379,2.379,0,0,1,.377-1.331,2.457,2.457,0,0,1,1.055-.891,3.668,3.668,0,0,1,1.557-.314,3.3,3.3,0,0,1,2.066.6,2.306,2.306,0,0,1,.873,1.745h-1.582a1.267,1.267,0,0,0-.427-.841,1.445,1.445,0,0,0-1-.339,1.622,1.622,0,0,0-1.055.326,1.172,1.172,0,0,0-.4.967,1.066,1.066,0,0,0,.257.747,1.619,1.619,0,0,0,.647.427,9.591,9.591,0,0,0,1.08.308,9.224,9.224,0,0,1,1.369.421,2.217,2.217,0,0,1,.9.691,2.051,2.051,0,0,1,.37,1.3,2.381,2.381,0,0,1-.358,1.256",
    transform: "translate(-664.611 -154.671)",
    fill: "#004ede"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_49",
    "data-name": "Path 49",
    d: "M938.962,214.3a2.614,2.614,0,0,1-1.048.954,3.426,3.426,0,0,1-1.62.364,3.562,3.562,0,0,1-2.2-.641,2.089,2.089,0,0,1-.854-1.771h1.532a1.339,1.339,0,0,0,.427.917,1.581,1.581,0,0,0,1.092.339,1.681,1.681,0,0,0,1.162-.377,1.239,1.239,0,0,0,.421-.967,1.02,1.02,0,0,0-.258-.735,1.692,1.692,0,0,0-.646-.415,9.876,9.876,0,0,0-1.067-.308,9.1,9.1,0,0,1-1.381-.42,2.219,2.219,0,0,1-.9-.7,2.081,2.081,0,0,1-.377-1.312,2.38,2.38,0,0,1,.377-1.331,2.456,2.456,0,0,1,1.055-.891,3.669,3.669,0,0,1,1.557-.314,3.3,3.3,0,0,1,2.066.6,2.307,2.307,0,0,1,.873,1.745h-1.582a1.267,1.267,0,0,0-.427-.841,1.445,1.445,0,0,0-1-.339,1.621,1.621,0,0,0-1.055.326,1.172,1.172,0,0,0-.4.967,1.066,1.066,0,0,0,.257.747,1.62,1.62,0,0,0,.647.427,9.585,9.585,0,0,0,1.08.308,9.225,9.225,0,0,1,1.369.421,2.216,2.216,0,0,1,.9.691,2.052,2.052,0,0,1,.37,1.3,2.38,2.38,0,0,1-.358,1.256",
    transform: "translate(-698.361 -154.671)",
    fill: "#004ede"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50",
    "data-name": "Path 50",
    d: "M965.558,208.208v2.649h3.014v1.105h-3.014v2.75h3.39v1.117h-4.822v-8.74h4.822v1.117Z",
    transform: "translate(-721.473 -154.969)",
    fill: "#004ede"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_51",
    "data-name": "Path 51",
    d: "M994.765,215.867l-2.185-3.541H991.7v3.541H990.27V207.14h3.013a3.808,3.808,0,0,1,1.7.345,2.4,2.4,0,0,1,1.042.936,2.522,2.522,0,0,1-1.827,3.817l2.31,3.629Zm-3.064-4.659h1.582a1.69,1.69,0,0,0,1.218-.389,1.434,1.434,0,0,0,.4-1.08,1.451,1.451,0,0,0-.4-1.093,1.691,1.691,0,0,0-1.218-.389H991.7Z",
    transform: "translate(-741.036 -155.006)",
    fill: "#004ede"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_52",
    "data-name": "Path 52",
    d: "M1020.539,207.14l2.574,7.245,2.6-7.245h1.519l-3.278,8.727H1022.3l-3.29-8.727Z",
    transform: "translate(-762.54 -155.006)",
    fill: "#004ede"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_11",
    "data-name": "Rectangle 11",
    width: 1.431,
    height: 8.727,
    transform: "translate(265.884 52.133)",
    fill: "#004ede"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_53",
    "data-name": "Path 53",
    d: "M1074.639,207.375a3.9,3.9,0,0,1,1.576,1.94h-1.72a2.311,2.311,0,0,0-.942-.986,2.839,2.839,0,0,0-1.394-.333,3.045,3.045,0,0,0-1.545.389,2.727,2.727,0,0,0-1.061,1.1,3.457,3.457,0,0,0-.383,1.658,3.5,3.5,0,0,0,.383,1.664,2.717,2.717,0,0,0,1.061,1.111,3.044,3.044,0,0,0,1.545.389,2.836,2.836,0,0,0,1.394-.333,2.308,2.308,0,0,0,.942-.986h1.72a3.865,3.865,0,0,1-1.576,1.934,4.586,4.586,0,0,1-2.48.678,4.511,4.511,0,0,1-2.248-.571,4.261,4.261,0,0,1-1.614-1.589,4.724,4.724,0,0,1,0-4.6,4.243,4.243,0,0,1,1.62-1.588,4.762,4.762,0,0,1,4.721.113",
    transform: "translate(-798.979 -154.67)",
    fill: "#004ede"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_54",
    "data-name": "Path 54",
    d: "M1109.6,208.208v2.649h3.014v1.105H1109.6v2.75h3.39v1.117h-4.822v-8.74h4.822v1.117Z",
    transform: "translate(-829.258 -154.969)",
    fill: "#004ede"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoLogin);
export default __webpack_public_path__ + "static/media/logo_login.4b33941b9c35c115b327c4b44a32ce89.svg";
export { ForwardRef as ReactComponent };